import { Microfrontend } from './Microfrontend.js';
export class DefaultMicrofrontend extends Microfrontend {
  constructor(tag: string) {
    super({
      tag,
      version: '*0.0.1'
    });
  }
}